module.exports = __webpack_public_path__ + "static/media/property_analysis_bac.0657e91d.svg";